import { SwgyHeaderKeysList } from "@swiggy-private/checkout-types";
import { MARKETPLACE_BUSINESS_LINE, MARKETPLACE_CATEGORY } from "@swiggy-private/payment-types";
import { GlobalHeaderState } from "@checkout-core/utils";

const getBusinessLine = (): string => {
    return GlobalHeaderState.getHeader(SwgyHeaderKeysList.marketplaceBusinessLine) || MARKETPLACE_BUSINESS_LINE.REGULAR;
};

const getMarketplaceCategory = (): string => {
    return GlobalHeaderState.getHeader(SwgyHeaderKeysList.marketplaceCategory) || MARKETPLACE_CATEGORY.FOOD;
};

export const isBusinessLineSuper = (): boolean => {
    return getBusinessLine() === MARKETPLACE_BUSINESS_LINE.SWIGGY_SUPER;
};

export const isBusinessLineSwiggyOne = (): boolean => {
    return getBusinessLine() === MARKETPLACE_BUSINESS_LINE.SWIGGY_ONE;
};

export const isBusinessLineDash = (): boolean => {
    return getBusinessLine() === MARKETPLACE_BUSINESS_LINE.DASH;
};

export function isBusinessLineSwiggyMoney(): boolean {
    return getBusinessLine() == MARKETPLACE_BUSINESS_LINE.SWIGGY_MONEY;
}

export const isBusinessLineDineout = (): boolean => {
    return getBusinessLine().toLowerCase() === MARKETPLACE_BUSINESS_LINE.DINEOUT;
};

export const isBusinessLineRegular = (): boolean => {
    return getBusinessLine().toLowerCase() === MARKETPLACE_BUSINESS_LINE.REGULAR;
};

export const isBusinessLinePayOnDelivery = (): boolean => {
    return getBusinessLine() === MARKETPLACE_BUSINESS_LINE.PAY_ON_DELIVERY;
};

export const isBusinessLineGifting = (): boolean => {
    return getBusinessLine().toLowerCase() === MARKETPLACE_BUSINESS_LINE.GIFTING;
};

export const isBusinessCategoryInstamart = (): boolean => {
    return isBusinessLineDash() && getMarketplaceCategory() === MARKETPLACE_CATEGORY.INSTAMART;
};
